var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "c-project-card u-color--one" }, [
    _vm.result.image
      ? _c("div", {
          staticClass: "c-project-card__img",
          style: { backgroundImage: "url(" + _vm.result.image.url + ")" }
        })
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "c-project-card__content" }, [
      _vm.result.type
        ? _c(
            "span",
            { staticClass: "c-project-card__ribbon u-color__ribbon" },
            [_vm._v(_vm._s(_vm.result.type))]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("h3", { staticClass: "c-project-card__title u-color__title" }, [
        _vm._v("\n      " + _vm._s(_vm.result.title) + "\n    ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "c-project-card__info" }, [
        _vm.result.location
          ? _c("p", { staticClass: "c-project-card__location" }, [
              _vm._v(_vm._s(_vm.result.location.name))
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.result.publicationDate
          ? _c("span", { staticClass: "c-project-card__location-divider" })
          : _vm._e(),
        _vm._v(" "),
        _vm.result.publicationDate
          ? _c(
              "time",
              {
                staticClass: "c-project-card__date",
                attrs: { datetime: _vm.result.publicationDate }
              },
              [_vm._v(_vm._s(_vm.result.publicationDate))]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.result.body
        ? _c("p", { staticClass: "c-project-card__summary" }, [
            _vm._v(_vm._s(_vm.result.body))
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.result.url
        ? _c(
            "a",
            {
              staticClass: "c-button c-button--brand",
              attrs: { href: _vm.result.url }
            },
            [_vm._v("View " + _vm._s(_vm.result.type) + " Details")]
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-721006ca", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-721006ca","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/geneco/community-search-results/projectResultsCardTwo.vue
// module id = 558
// module chunks = 0